export const isArrayWithItems = (maybeArray: unknown): boolean => Array.isArray(maybeArray) && maybeArray.length > 0;

/**
 * like [].every, but treats entry as a function, calls it and returns its result from `every` callback
 */
export const everyEvaluate = (funcs: (() => boolean)[]): boolean => funcs.every((func) => func());
